import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";

// Wave-17 Item 1.1 — Staff CBL dispute page lazy-loaded.
const CBLDisputePage = lazy(() => import("@/pages/Staff/CBLDispute/Page"));

export const CblDisputeRoute = () => (
  <div className="flex flex-col w-full min-h-full">
    <SiteHeader header="LL88" />
    <Suspense fallback={null}>
      <CBLDisputePage />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/staff/cbl-dispute/$disputeId")({
  component: CblDisputeRoute,
});
